import { InstrumentsContainer } from "./Instruments.styled";
import { InstrumentItem } from "./InstrumentItem";
import { useState } from "react";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { useTranslation } from "react-i18next";
import { INSTRUMENT_NAME } from "../../../constants";

interface InstrumentsProps {
	subscription?: boolean;
}

export const Instruments = observer(({ subscription = false }: InstrumentsProps) => {
	const { pricingActualStore } = useStores();

	const { t } = useTranslation();

	const [chooseInstrumentId, setChooseInstrumentId] = useState<number>(1);

	const handleOnChangeInstrument = (instrument_id: number) => {
		setChooseInstrumentId(instrument_id);
		pricingActualStore.setInstrumentId(instrument_id);
	};

	return (
		<InstrumentsContainer $subscription={subscription}>
			<InstrumentItem
				isActive={chooseInstrumentId === 1}
				value={1}
				name={INSTRUMENT_NAME.GUITAR}
				onChangeInstrument={handleOnChangeInstrument}
			>
				{t("instruments.guitar")}
			</InstrumentItem>
			<InstrumentItem
				isActive={chooseInstrumentId === 2}
				value={2}
				name={INSTRUMENT_NAME.KEYBOARD}
				onChangeInstrument={handleOnChangeInstrument}
			>
				{t("instruments.keyboard")}
			</InstrumentItem>
			<InstrumentItem
				isActive={chooseInstrumentId === 4}
				value={4}
				name={INSTRUMENT_NAME.SAXOPHONE}
				onChangeInstrument={handleOnChangeInstrument}
			>
				{t("instruments.saxophone")}
			</InstrumentItem>
		</InstrumentsContainer>
	);
});
